export default class CareerColumnsNames {
  constructor(rawData = {}) {
    this.id = rawData.id;
    this.name = rawData.name;
    this.displayName = rawData.displayName;
    this.isActive = rawData.isActive;
    this.creationDate = rawData.creationDate;
  }
}
